/* global require, Toasts */
;$(function () {
  'use strict'

  const subscriptionSelector = '[data-notifications-subscription]'
  const autoSubscriptionSelector = '[data-notifications-subscription-auto]'
  const subscriptionConfirmationSelector = '[data-notifications-subscription-confirm]'

  const subscribe = function (url, kind, objectId, textSubscribe, textUnsubscribe, $modalToCloseOnSuccess, anotherActionOnFail, anotherActionUrl, $confirmationModalOnFail) {
    const $objectSubscriptionElems = $(subscriptionSelector).filter('[data-kind="' + kind + '"][data-object-id="' + objectId + '"]')
    const $subscribeElems = $objectSubscriptionElems.filter('[data-action="subscribe"]')
    const $unsubscribeElems = $objectSubscriptionElems.filter('[data-action="unsubscribe"]')

    $.post(url, {'kind': kind, 'object_id': objectId})
      .done(function (response) {
        var errorMessage = 'Что-то пошло не так, попробуйте позднее'
        if (response.success) {
          $unsubscribeElems.data('id', response.id).attr('data-id', response.id)

          $subscribeElems.addClass('layout__none')
          if ($unsubscribeElems.length) {
            $unsubscribeElems.removeClass('layout__none')
          }

          Toasts.pushToast(textSubscribe || 'Вы успешно подписались', 'success', undefined, 5000)

          if ($modalToCloseOnSuccess) {
            window.Modal.closeModal($modalToCloseOnSuccess)
          }
        }
        else {
          Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        }
      })
      .fail(function (xhr) {
        var errorMessage = 'Что-то пошло не так, попробуйте позднее'

        if (anotherActionOnFail && xhr.status === 409) {
          if (typeof (xhr.responseJSON) === 'undefined' || typeof (xhr.responseJSON.id) === 'undefined') {
            Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
            return
          }

          const id = xhr.responseJSON.id
          if ($confirmationModalOnFail) {
            const $confirmation = $confirmationModalOnFail.find(subscriptionConfirmationSelector)
            $confirmation.data('url', anotherActionUrl)
            $confirmation.data('action', 'unsubscribe')
            $confirmation.data('id', id)
            $confirmation.data('kind', kind)
            $confirmation.data('objectId', objectId)
            $confirmation.data('textSubscribe', textSubscribe)
            $confirmation.data('textUnsubscribe', textUnsubscribe)
            window.Modal.openModal($confirmationModalOnFail)
          }
          else {
            unsubscribe(anotherActionUrl, id, kind, objectId)
          }
        }
        else {
          if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.error) !== 'undefined') {
            errorMessage = xhr.responseJSON.error
          }

          if (xhr.status === 409) {
            $unsubscribeElems.data('id', xhr.responseJSON.id).attr('data-id', xhr.responseJSON.id)

            $subscribeElems.addClass('layout__none')
            if ($unsubscribeElems.length) {
              $unsubscribeElems.removeClass('layout__none')
            }
          }

          Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        }
      })
  }

  const unsubscribe = function (url, id, kind, objectId, textSubscribe, textUnsubscribe, $modalToCloseOnSuccess, anotherActionOnFail, anotherActionUrl, $confirmationModalOnFail) {
    const $objectSubscriptionElems = $(subscriptionSelector).filter('[data-kind="' + kind + '"][data-object-id="' + objectId + '"]')
    const $subscribeElems = $objectSubscriptionElems.filter('[data-action="subscribe"]')
    const $unsubscribeElems = $objectSubscriptionElems.filter('[data-action="unsubscribe"]')

    $.post(url, {'id': id})
      .done(function (response) {
        var errorMessage = 'Что-то пошло не так, попробуйте позднее'
        if (response.success) {
          $subscribeElems.removeClass('layout__none')
          $unsubscribeElems.addClass('layout__none')
          $unsubscribeElems.removeData('id').attr('data-id', null)

          Toasts.pushToast(textUnsubscribe || 'Вы успешно отписались', 'success', undefined, 5000)

          if ($modalToCloseOnSuccess) {
            window.Modal.closeModal($modalToCloseOnSuccess)
          }
        }
        else {
          Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        }
      })
      .fail(function (xhr) {
        var errorMessage = 'Что-то пошло не так, попробуйте позднее'

        if (anotherActionOnFail && xhr.responseJSON && xhr.responseJSON.unsubscribed) {
          if ($confirmationModalOnFail) {
            const $confirmation = $confirmationModalOnFail.find(subscriptionConfirmationSelector)
            $confirmation.data('url', anotherActionUrl)
            $confirmation.data('action', 'subscribe')
            $confirmation.data('id', null)
            $confirmation.data('kind', kind)
            $confirmation.data('objectId', objectId)
            $confirmation.data('textSubscribe', textSubscribe)
            $confirmation.data('textUnsubscribe', textUnsubscribe)
            window.Modal.openModal($confirmationModalOnFail)
          }
          else {
            subscribe(anotherActionUrl, kind, objectId)
          }
        }
        else {
          if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.error) !== 'undefined') {
            errorMessage = xhr.responseJSON.error
          }

          if (xhr.responseJSON && xhr.responseJSON.unsubscribed) {
            $subscribeElems.removeClass('layout__none')
            $unsubscribeElems.addClass('layout__none')
            $unsubscribeElems.removeData('id').attr('data-id', null)
          }

          Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        }
      })
  }

  $(document).on('click', subscriptionSelector, function (e) {
    e.preventDefault()

    const $this = $(this)
    const action = $this.data('action')
    const url = $this.data('url')
    const id = $this.data('id')
    const kind = $this.data('kind')
    const objectId = $this.data('objectId')
    const textSubscribe = $this.data('textSubscribe')
    const textUnsubscribe = $this.data('textUnsubscribe')
    const errorMessage = 'Что-то пошло не так, попробуйте перезагузить страницу'

    if (action === 'subscribe') {
      if (!kind || !objectId) {
        Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        return
      }
    }
    else if (action === 'unsubscribe') {
      if (!id || !kind || !objectId) {
        Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        return
      }
    }

    if (action === 'subscribe') {
      subscribe(url, kind, objectId, textSubscribe, textUnsubscribe)
    }
    else if (action === 'unsubscribe') {
      unsubscribe(url, id, kind, objectId, textSubscribe, textUnsubscribe)
    }
  })

  // auto subscription

  $(document).on('click', autoSubscriptionSelector, function (e) {
    e.preventDefault()

    const $this = $(this)
    const action = $this.data('action')
    const url = $this.data('url')
    const anotherActionUrl = $this.data('anotherActionUrl')
    const id = $this.data('id')
    const kind = $this.data('kind')
    const objectId = $this.data('objectId')
    const textSubscribe = $this.data('textSubscribe')
    const textUnsubscribe = $this.data('textUnsubscribe')
    const failConfirmation = $this.data('failConfirmation')
    const failModalId = $this.data('failModalId')
    const confirmationModalId = $this.data('confirmationModalId')
    const $failModal = failModalId ? $('#' + failModalId) : null
    const $confirmationModal = confirmationModalId ? $('#' + confirmationModalId) : null
    const errorMessage = 'Что-то пошло не так, попробуйте перезагузить страницу'

    if (action === 'subscribe') {
      if (!kind || !objectId) {
        Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        return
      }
    }
    else if (action === 'unsubscribe') {
      if (!id || !kind || !objectId) {
        Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        return
      }
    }

    if (action === 'subscribe') {
      subscribe(
        url,
        kind,
        objectId,
        textSubscribe,
        textUnsubscribe,
        confirmationModalId ? $confirmationModal : null,
        true,
        anotherActionUrl,
        failConfirmation === 'all' || failConfirmation === 'unsubscribe' ? $failModal : null
      )
    }
    else if (action === 'unsubscribe') {
      unsubscribe(
        url,
        id,
        kind,
        objectId,
        textSubscribe,
        textUnsubscribe,
        confirmationModalId ? $confirmationModal : null,
        true,
        anotherActionUrl,
        failConfirmation === 'all' || failConfirmation === 'subscribe' ? $failModal : null
      )
    }
  })

  $(document).on('click', subscriptionConfirmationSelector, function (e) {
    e.preventDefault()

    const $this = $(this)
    const action = $this.data('action')
    const url = $this.data('url')
    const id = $this.data('id')
    const kind = $this.data('kind')
    const objectId = $this.data('objectId')
    const textSubscribe = $this.data('textSubscribe')
    const textUnsubscribe = $this.data('textUnsubscribe')
    const $modal = $this.closest('.modall')

    const errorMessage = 'Что-то пошло не так, попробуйте перезагузить страницу'
    if (action === 'subscribe') {
      if (!kind || !objectId) {
        Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        return
      }
    }
    else if (action === 'unsubscribe') {
      if (!id || !kind || !objectId) {
        Toasts.pushToast(errorMessage, 'fail', undefined, 5000)
        return
      }
    }

    if (action === 'subscribe') {
      subscribe(url, kind, objectId, textSubscribe, textUnsubscribe, $modal)
    }
    else if (action === 'unsubscribe') {
      unsubscribe(url, id, kind, objectId, textSubscribe, textUnsubscribe, $modal)
    }
  })
})
